import { useCreateOperator } from '../../../contexts/CreateOperatorContext';
import { ResultsProgress } from './ResultsProgress';
import { ResultsHeader } from './ResultsHeader';
import { ResultsFooter } from './ResultsFooter';
import React from 'react';
import { ResultsSummary } from './ResultsSummary';

export const Results = () => {
  const { creatingOperator } = useCreateOperator();

  if (creatingOperator === false) return null;

  return (
    <div className="flex flex-col items-center gap-4">
      <ResultsHeader />
      <div className="max-w-[400px] w-full">
        <ResultsProgress />
        <ResultsSummary />
        <ResultsFooter />
      </div>
    </div>
  );
};
